import { ImageType } from '@inter-ikea-storageone/range';
import { GalleryConfig } from 'rangeConfig/@types';

const platsaGalleryConfig: GalleryConfig = {
  default: [
    {
      sprs: [
        { id: 'SPR-49522927' },
        { id: 'SPR-39425352' },
        { id: 'SPR-29424372' },
        { id: 'SPR-59326469' },
        { id: 'SPR-79436914' },
        { id: 'SPR-69424332' },
        { id: 'SPR-09522910', image: { index: 1, type: ImageType.CPP } },
        { id: 'SPR-79436966' },
        { id: 'SPR-69437080' },
        { id: 'SPR-49336548' }
      ]
    }
  ]
};

export default platsaGalleryConfig;
